module.exports = __webpack_public_path__ + "static/media/SF-14-A.4cdd5a4b.mp3";